import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const CatalogoReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Obtener lista de zonas
   */
  builder
    .addCase(Types.GET_ZONAS_LOADING, (state) => {
      state.getZonasLoading = true;
      state.getZonasError = null;
    })
    .addCase(Types.GET_ZONAS_SUCCESS, (state, action) => {
      const { getZonasData } = action;
      state.getZonasData = getZonasData;
      state.getZonasLoading = false;
      state.getZonasError = null;
    })
    .addCase(Types.GET_ZONAS_FAILURE, (state, action) => {
      const { getZonasError } = action;
      state.getZonasData = INITIAL_STATE.getZonasData;
      state.getZonasLoading = false;
      state.getZonasError = getZonasError;
    });

  /**
  * Obtener lista de provincias por zona
  */
  builder
    .addCase(Types.GET_PROVINCIAS_LOADING, (state) => {
      state.getProvinciasLoading = true;
      state.getProvinciasError = null;
    })
    .addCase(Types.GET_PROVINCIAS_SUCCESS, (state, action) => {
      const { getProvinciasData } = action;
      state.getProvinciasData = getProvinciasData;
      state.getProvinciasLoading = false;
      state.getProvinciasError = null;
    })
    .addCase(Types.GET_PROVINCIAS_FAILURE, (state, action) => {
      const { getProvinciasError } = action;
      state.getProvinciasData = INITIAL_STATE.getProvinciasData;
      state.getProvinciasLoading = false;
      state.getProvinciasError = getProvinciasError;
    });

  /**
  * Obtener lista de diagnosticos
  */
  builder
    .addCase(Types.GET_DIAGNOSTICOS_LOADING, (state) => {
      state.getDiagnosticosLoading = true;
      state.getDiagnosticosError = null;
    })
    .addCase(Types.GET_DIAGNOSTICOS_SUCCESS, (state, action) => {
      const { getDiagnosticosData } = action;
      state.getDiagnosticosData = getDiagnosticosData;
      state.getDiagnosticosLoading = false;
      state.getDiagnosticosError = null;
    })
    .addCase(Types.GET_DIAGNOSTICOS_FAILURE, (state, action) => {
      const { getDiagnosticosError } = action;
      state.getDiagnosticosData = INITIAL_STATE.getDiagnosticosData;
      state.getDiagnosticosLoading = false;
      state.getDiagnosticosError = getDiagnosticosError;
    });
});